import {useEffect, useState} from 'react'
import {Link, useHistory} from 'react-router-dom'
import axios from 'axios'
import {validate, validateClicLogin} from '../../utils/validateLogin'
import {useDispatch, useSelector} from 'react-redux'
import {userLoginSave, userPropinaSave} from '../../actions/userLogin.actions'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import InputIcon from '../../components/Inputs/InputIcon'
import DarkMail from '../../media/felsv/DarkUser.svg'
import SecondaryMail from '../../media/felsv/SecondaryUser.svg'
import DarkPass from '../../media/felsv/dark_lock-key-alt_icon.svg'
import SecondaryPass from '../../media/felsv/secondary_lock-key-alt_icon.svg'
import {KEYS} from '../../constants/keysStorage'
import {
  generalOpenModalError,
  generalOpenModalInfo,
  generalShowLoader,
} from '../../actions/general.actions'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionsPeticiones} from '../../actions/action-creators'
import {catalogosClear} from '../../actions/catalogos.actions'
import {DICCIONARIO} from '../../constants/Diccionario'
import {REGEX_USER_NAME} from '../../constants/Regex'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import useFacturaExportacion from '../../actions/factura-exportacion.actions'
import ModalConfirm from '../../components/Modals/Generales/ModalConfirm'

const url_legal = process.env.REACT_APP_LEGAL;

export const LoginUsuario = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [AlertaLogin, setAlertaLogin] = useState(false)
  const [ValidoLogin, setValidoLogin] = useState(false)
  const [MessageAlerta, setMessageAlerta] = useState(false)
  const [DataUser, setDataUser] = useState<any>([]);
  const loader = useSelector((state: State) => state.general.loader)
  const {peticionesGenerales} = bindActionCreators(actionsPeticiones, dispatch)
  const {cargarCatalogosExportacion} = useFacturaExportacion()
  interface Data {
    password: string
    email: string
  }

  const [errors, setErrors] = useState<Data>({
    password: '',
    email: '',
  })
  const [Datos, setDatos] = useState<Data>({
    password: '',
    email: '',
  })

  useEffect(() => {
    localStorage.removeItem(KEYS.USERNAME_CLIENTE)
    localStorage.removeItem(KEYS.USERNAME_CLIENTE_RESTORE)
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.INTERNO)
    localStorage.removeItem(KEYS.LIMITAR_USO_FELES)
    dispatch(catalogosClear())
    window.scroll(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleError = (e: any) =>
    setErrors(validate({...Datos, [e.target.name]: e.target.value}, e.target.name, errors))

  const handleInputChange = (e: any) => {
    if (e.target.name === 'email' && e.target.value) {
      if (!REGEX_USER_NAME.test(e.target.value)) return
    }
    setDatos({...Datos, [e.target.name]: e.target.value})
    handleError(e)
  }
  const handleChange = (e: any) => {
    setDatos({...Datos, [e.target.name]: e.target.value})
    handleError(e)
  }

  const ConfirmarAlertaLogin_NoEntra = async () => {
    setMessageAlerta(false)
  }
  
  const ConfirmarAlertaLogin_LimitarFeles = async () => {
    localStorage.setItem(KEYS.ID_CLIENT, DataUser.id.toString())
    localStorage.setItem(KEYS.EMAIL_CLIENT, DataUser?.email)
    localStorage.setItem(KEYS.NAME_CLIENT, DataUser?.name)
    localStorage.setItem(KEYS.ROL, DataUser?.role)
    localStorage.setItem(KEYS.USERNAME_CLIENTE, DataUser?.username)
    localStorage.setItem(KEYS.CODIGO_EMPRESA, DataUser?.codigo_empresa)
    localStorage.setItem(KEYS.LOGO_EMPRESA, DataUser?.logo)

    setMessageAlerta(false)
    peticionesGenerales(cargarCatalogosExportacion)
    history.push({pathname: '/home', state: DataUser?.id})
  }

  const login = async (e: any) => {
    e.preventDefault()
    if (loader) return
    let token = ''
    let errors = validateClicLogin(Datos)
    if (errors) return setErrors(errors)

    dispatch(generalShowLoader(true))
    await http
      .post(ENDPOINTS.LOGIN_ACCESS, {
        username: Datos.email,
        password: Datos.password,
      })
      .then(async (datos: any) => {
        if (datos.acceso === 0 && datos.interno === 0) {
          // * ACCESO CORRECTO
          setValidoLogin(datos?.alertas?.valido)
          const LimitarFuncionalidades = datos?.alertas?.limitarFeles
          setAlertaLogin(datos?.alertas?.message === ""? false : true)

          if (datos.data && datos?.alertas?.valido) {
            token = datos.data.split(';')[0].split('=')[1]
            axios.defaults.headers.common = {Authorization: `Bearer ${token}`}
            await http
              .get(`${ENDPOINTS.LOGIN_GET_INFO}?username=${Datos.email}`, {}, null, {
                Authorization: `Bearer ${token}`,
              })
              .then(async (subdatos: any) => {
                dispatch(userLoginSave(subdatos?.data))
                await http
                  .post(ENDPOINTS.LOGIN_GET_AUTH_HACIENDA, {
                    user: subdatos?.data?.username,
                    pwd: Datos?.password,
                    correo: subdatos?.data?.email,
                  })
                  .then(async (authAccesos: any) => {
                    const {body} = authAccesos.body
                    if (body?.status === 'ERROR') {
                      dispatch(generalOpenModalInfo(`Fallo en la autenticación con el sistema de Hacienda: Sus credenciales de empresa son correctas para FELES, pero no coinciden con los datos registrados en el sistema de Hacienda. Por favor, póngase en contacto con el servicio técnico para resolver este problema.`))
                      return
                    }
                    localStorage.setItem(KEYS.TOKEN, token)
                    // localStorage.setItem(KEYS.TOKEN, authAccesos.body.tokenGateway)

                    const BodyOdooActivo = {
                      "idEmpresa": subdatos.data.codigo_empresa,
                      "idSucursal": subdatos.data.sucursal_seleccionada,
                      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? ''
                    }

                    const ResPropina: any = await http.post(ENDPOINTS.OBTENER_INFORMACION_PROPINAS, BodyOdooActivo, {}, KEYS.TOKEN)
                    
                    if(ResPropina?.body)
                      dispatch(userPropinaSave(ResPropina?.body[0]))

                    if (datos.data.validate === false)
                    localStorage.setItem(KEYS.LIMITAR_USO_FELES, LimitarFuncionalidades)
                    
                    setMessageAlerta(datos?.alertas?.message !== "")
                    if (subdatos.data.validate === false) {
                      history.push({pathname: '/restore', state: Datos})
                    } else if(datos?.alertas?.message === "") {
                      localStorage.setItem(KEYS.ID_CLIENT, subdatos.data.id.toString())
                      localStorage.setItem(KEYS.EMAIL_CLIENT, subdatos.data.email)
                      localStorage.setItem(KEYS.NAME_CLIENT, subdatos.data.name)
                      localStorage.setItem(KEYS.ROL, subdatos.data.role)
                      localStorage.setItem(KEYS.USERNAME_CLIENTE, subdatos.data.username)
                      localStorage.setItem(KEYS.CODIGO_EMPRESA, subdatos.data.codigo_empresa)
                      localStorage.setItem(KEYS.LOGO_EMPRESA, subdatos.data.logo)

                      peticionesGenerales(cargarCatalogosExportacion)
                      history.push({pathname: '/home', state: subdatos.data.id})
                    }
                    setMessageAlerta(datos?.alertas?.message)
                    setDataUser(subdatos.data)
                    
                  })
                  .catch((errs) => {
                    let message = 'No se logró obtener los accesos, inténtelo nuevamente'
                    dispatch(generalOpenModalError(errs?.response?.data?.message ?? message, errs?.response?.data?.status))
                  })
              })
              .catch((err) => {
                let message = 'No se logró validar las credenciales del usuario, inténtelo nuevamente'
                dispatch(generalOpenModalError(err?.response?.data?.message ?? message,err?.response?.data?.status))
              })
          } else {
            if(datos?.alertas?.message !== "")
              setMessageAlerta(datos?.alertas?.message)
            else
              dispatch(generalOpenModalError(datos.message))
          }
        } else if (datos.acceso === 0 && datos.interno === 1) {
          // * REINICIAR CONTRASEÑA
          token = datos.data.split(';')[0].split('=')[1]
          localStorage.setItem(KEYS.TOKEN, token)
          localStorage.setItem(KEYS.USERNAME_CLIENTE_RESTORE, Datos.email)
          history.push('/user-restore')
        } else if (datos.acceso === 1) {
          // * VERIFICAR CUENTA
          localStorage.setItem(KEYS.USERNAME_CLIENTE, Datos.email)
          if (datos.data) {
            token = datos.data.split(';')[0].split('=')[1]
            localStorage.setItem(KEYS.TOKEN, token)
          }
          if (datos.interno) localStorage.setItem(KEYS.INTERNO, String(datos.interno))
          history.push('/account-confirm2')
        } else {
          // * ACCESO INCORRECTO
          dispatch(generalOpenModalError(datos.message))
        }
      })
      .catch((err) => {
        let message = 'No se logró validar las credenciales del usuario, inténtelo nuevamente'
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message,err?.response?.data?.status))
      })
      .finally(() => {
        dispatch(generalShowLoader(false))
      })
  }

  return (
    <DesignExterno
      title={
        <span className='xl'>
          Bienvenido a <span style={{color: '#019FC5'}}>FELes APP</span>
        </span>
      }
    >
      {
        MessageAlerta &&
          <ModalConfirm
            title='Alerta'
            detail={MessageAlerta}
            messageAction='Aceptar'
            actionConfirm={ValidoLogin? ConfirmarAlertaLogin_LimitarFeles : ConfirmarAlertaLogin_NoEntra}
            Styles={{minWidth: '25%', maxWidth: '550px'}}
          />
      }
      <form  className='form-content centrar-horizontal' onSubmit={login}>
        <div>
          <h2 className='h2-titles xl'>Inicia Sesión</h2>
          <div className='m'>Ingresa tu usuario y contraseña para continuar.</div>
        </div>
        <div className='form-separator'></div>
        <div>
          <label htmlFor='idEmail' className='field-label m'>
            {DICCIONARIO.USERNAME}
          </label>
          <InputIcon
            secondaryIcon={SecondaryMail}
            darkIcon={DarkMail}
            type='text'
            autoFocus
            className='m text-field-icon email w-input'
            name='email'
            dataName='Email'
            placeholder={DICCIONARIO.USERNAME}
            id='idEmail'
            maxLength={20}
            onChange={handleInputChange}
            onBlur={handleError}
            value={Datos.email}
          />
          {errors.email && <p className='alert s'>{errors.email}</p>}
        </div>
        <div>
          <label htmlFor='idPassword' className='field-label m'>
            {DICCIONARIO.PASSWORD}
          </label>
          <InputIcon
            secondaryIcon={SecondaryPass}
            darkIcon={DarkPass}
            type='password'
            className='m text-field-icon pass w-input'
            name='password'
            dataName=''
            placeholder={DICCIONARIO.PASSWORD}
            id='idPassword'
            maxLength={50}
            onChange={handleChange}
            onBlur={handleError}
            value={Datos.password}
          />
          {errors.password && <p className='alert s'>{errors.password}</p>}
          <div className='text-note'>
            <Link to='/forgot' style={{textDecoration: 'none'}}>
              <span className='linktext m'>¿Olvidaste tu contraseña?</span>
            </Link>
          </div>
        </div>
        <div className='m buttons-div m'>
          <button type='submit' className='m button w-inline-block'>
            Iniciar Sesión
          </button>
          <Link to='/create' className='m button transparent w-inline-block'>
            <div>Registrarme</div>
          </Link>
        </div>
      </form>
      <div style={{marginTop: '15px'}}>
          <p className='s'>Al iniciar sesión, aceptas nuestros <a className='link-legal' href={`${url_legal}/terminos-y-condiciones.html`} target='_blank'>Términos y condiciones</a> y las <a className='link-legal' target='_blank' href={`${url_legal}/politica-de-privacidad.html`}>Políticas de privacidad</a>.</p>
      </div>
    </DesignExterno>
  )
}
